import { UPDropdownItem } from 'components/dropdown';
import { RootState } from 'store';

export const countriesErrorSelector = (state: RootState): boolean => state.countries.countriesError;
export const countriesNames = (state: RootState): UPDropdownItem[] => state.countries.countriesNames;

export const countriesLoadingSelector = (state: RootState): boolean => state.countries.loading;
